<template>
  <section
    v-if="
      items.is_open_blog == 1 &&
      blog.length > 0 &&
      params.limit > 0 &&
      indexOpenType == 1
    "
    class="iv2-section-blog position-relative"
  >
    <div class="container-fluid">
      <div class="row clearfix">
        <div class="column full text-center">
          <p class="size-14">
            {{ subtitle }}
          </p>
          <h3 class="theme__heading-text">
            {{ title }}
          </h3>
        </div>
        <div class="column full">
          <div class="spacer height-40"></div>
        </div>
        <div
          v-for="item in limitCount"
          :key="item.id"
          class="iv2-top-blog__item mb-3 mb-md-4 col-6 col-xl-4"
        >
          <NewsCard :content="item" />
        </div>
        <div class="column full">
          <div class="spacer height-40"></div>
          <div class="text-center">
            <span>
              <router-link
                :to="{ name: 'blog', query: Object.assign({}, $route.query) }"
                class="iv2-top-blog__btn theme__main-btn is-btn is-btn-ghost2 size-18"
                >{{ $store.state.publicLang.page.blog_button }}</router-link
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import NewsCard from "@/components/items/BaseNewsCard.vue";

export default {
  components: {
    NewsCard,
  },

  props: {
    items: Object,
  },

  data() {
    return {
      blog: [],
      title: "",
      subtitle: "",
      indexOpenType: "",
      params: {
        type: "blog",
        limit: "",
      },
    };
  },

  computed: {
    limitCount() {
      return this.blog.slice(0, this.params.limit);
    },
  },

  created() {
    this.params.limit = this.items.display_blog_number;
  },

  mounted() {
    const blogRepository = this.$repository.get("news");
    const blog = blogRepository.index(this.params);
    const self = this;
    blog
      .then((result) => {
        const res = result.data.response;

        // customize
        self.blog = res.data.map((item) => {
          // YYYY年MM月DD日という文字列から、年月日の数値を配列型に変換する
          const date = item.opened_at.split("年");
          const year = date[0];
          const month = date[1].split("月")[0];
          const day = date[1].split("月")[1].split("日")[0];
          return {
            ...item,
            opened_at: new Date(year, month - 1, day).toLocaleDateString(
              "en-us",
              {
                year: "numeric",
                month: "long",
                day: "2-digit",
              }
            ),
          };
        });

        self.title = res.blog_title;
        self.subtitle = res.blog_subtitle;
        if (self.$route.query.mode == "preview") {
          self.indexOpenType = 1;
        } else {
          self.indexOpenType = res.blog_open_type;
        }
      })
      .catch((error) => {
        console.error(error);
      });
    this.gridHeight();
  },

  updated() {
    this.gridHeight();
  },

  methods: {
    gridHeight() {
      let title = document.getElementsByClassName("iv2-news-card__title");
      let titleMaxHeight = 0;
      let titleArray = new Array();

      Array.prototype.forEach.call(title, (el) => {
        el.style.height = "";
        titleArray.push(el.clientHeight);
      });

      titleMaxHeight = Math.max.apply(null, titleArray);

      Array.prototype.forEach.call(title, (el) => {
        el.style.height = titleMaxHeight + "px";
      });
    },
  },
};
</script>

<style lang="scss">
.iv2-section-blog {
  padding: 40px 0 80px;

  .iv2-top-blog__btn {
    letter-spacing: 2px;
    max-width: 100%;
    padding: 10px 80px;
    margin: 10px 13px;
  }
}

/* SP Only */
@media (max-width: 767px) {
  .iv2-section-blog {
    .iv2-top-blog__item {
      padding-right: 5px;
      padding-left: 5px;
    }
  }
}
</style>
